import React from "react";
import { Box, Typography } from "@mui/material";

interface ResultsHeaderProps {
    title: string;
    subtitle?: string;
    logoSrc: string;
}

function ResultsHeader({ title, subtitle, logoSrc }: ResultsHeaderProps) {
    return (
        <Box
            sx={{
                width: "100%",
                px: { xs: 2, sm: 3, md: 6 },
                pt: { xs: 3, md: 5 },
                pb: { xs: 3, md: 6 },

                // ✅ mobile stacks, desktop is 3-column
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "170px 1fr 170px" },
                alignItems: "center",
                gap: { xs: 2, md: 0 },
            }}
        >
            {/* LEFT: Logo (centered on mobile) */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: { xs: "center", md: "flex-start" },
                }}
            >
                <Box
                    component="img"
                    src={logoSrc}
                    alt="Paws on Plates Logo"
                    sx={{
                        width: { xs: 120, sm: 140, md: 170 },
                        height: "auto",
                    }}
                />
            </Box>

            {/* CENTER: Title + Subtitle */}
            <Box
                sx={{
                    minWidth: 0,
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Prompt",
                        fontWeight: 800,
                        fontSize: { xs: "26px", sm: "32px", md: "48px" },
                        lineHeight: { xs: 1.05, md: "100%" },
                        color: "#7B3306",

                        // ✅ prevents weird layout jumps on long titles
                        px: { xs: 0.5, md: 0 },
                        wordBreak: "break-word",
                    }}
                >
                    {title}
                </Typography>

                {subtitle && (
                    <Typography
                        sx={{
                            mt: { xs: 1, md: 1.2 },
                            fontFamily: "Archivo",
                            fontWeight: 400,
                            fontSize: { xs: "14px", sm: "15px", md: "16px" },
                            lineHeight: { xs: "20px", md: "24px" },
                            color: "#4A301E",
                            opacity: 0.75,
                            maxWidth: { xs: "100%", md: 620 },
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>

            {/* RIGHT: Spacer for perfect centering on desktop */}
            <Box sx={{ display: { xs: "none", md: "block" } }} />
        </Box>
    );
}

export default ResultsHeader;